import React, {Component} from 'react';
import "./footer.css";

class Footer extends Component {
    constructor(props){
        super(props);
    }
    render() {
        return (
            <div className="text-center mt-4 footer" >
                <ul className="footer-ul mr-5">
                    <a href="https://www.facebook.com/profile.php?id=100009567481817" className="footer-li"><l1 className=""><i className="fa fa-facebook-f"></i></l1></a>
                    <a href="https://twitter.com/AvisekShaw6?s=09" className="footer-li"><l1 className=""><i className="fa fa-twitter"></i></l1></a>
                    <a href="https://www.github.com/shawavisek35" className="footer-li"><l1 className=""><i className="fa fa-github"></i></l1></a>
                    <a href="https://www.linkedin.com/in/avisek-shaw-78136b196/" className="footer-li"><l1 className=""><i className="fa fa-linkedin"></i></l1></a>
                    <a href="https://www.instagram.com/indorap_avisek3524/feed/" className="footer-li"><l1 className=""><i className="fa fa-instagram"></i></l1></a>
                
                </ul>
            </div>
            
        );
    }
}

export default Footer;
